// extracted by mini-css-extract-plugin
export default {"softwarePlanPadding":"mAZF70It--SoftwarePlanMonthlyPricing_softwarePlanPadding__w754o"};